export default "__VITE_ASSET__Dd2YX_iM__"